import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {SidemenuComponent} from './sidemenu/sidemenu.component';
import {Daterangepicker} from 'ng2-daterangepicker';
import { RouterModule } from '@angular/router';
import { SearchComponent } from './search/search.component';
import { SearchPanelComponent } from './search-panel/search-panel.component';
import { BreadCrumbComponent } from './bread-crumb/bread-crumb.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { SharedModule } from '../shared/shared.module';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {AppLayoutComponent} from './app-layout/app-layout.component';
import {ChangeFormatDirective} from './directives/change-format.directive';
import {DialogService} from './services/dialog.service';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import { NotificationsComponent } from './notifications/notifications.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {FooterDashboardComponent} from './footer-dashboard/footer-dashboard.component';
import {HeaderDashboardComponent} from './header-dashboard/header-dashboard.component';
import { UserConsentsDialogComponent } from './user-consents-dialog/user-consents-dialog.component';
import {MatCheckboxModule} from '@angular/material/checkbox';


@NgModule({
  declarations: [
    AppLayoutComponent,
    HeaderComponent,
    HeaderDashboardComponent,
    FooterComponent,
    FooterDashboardComponent,
    SearchComponent,
    SearchPanelComponent,
    SidemenuComponent,
    BreadCrumbComponent,
    NotificationsComponent,
    // CORE - DIRECTIVES
    ChangeFormatDirective,
    UserConsentsDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,

    Daterangepicker,
    FormsModule,
    RouterModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatDatepickerModule,
    MatCheckboxModule,
  ],
  exports: [
    AppLayoutComponent,
    HeaderComponent,
    HeaderDashboardComponent,
    FooterComponent,
    FooterDashboardComponent,
    SidemenuComponent,
    SearchComponent,
    SearchPanelComponent,
    BreadCrumbComponent
  ],
  providers: [
    DialogService,
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 2500}}
  ]
})
export class CoreModule {
}
